export enum TABLE_ORDER {
    ASC = 1,
    DSC = -1,
}
